export function dropdownProductValidate(product){
    var result = true;

    result = validateId(product.id);
    result = validateSku(product.sku);
    result = validateType(product.type);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateSku(sku){
    if(typeof sku === 'string' && sku.trim() !== '') return true;
    else return false;
}

function validateType(type){
    if(typeof type === 'string' || type.trim() !== '') return true;
    else return false;
}